export default "__VITE_ASSET__49768494__"